import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { isUseIframePay } from '@/config/insurance'
import Apphost, { isApp } from '@/utils/app'
import { JijiaInsranceAppletsValue } from '@/types/insurance'
import { showConfirmModal } from '@/utils/tools'
import wx from 'weixin-js-sdk'

interface PayHandleParams {
  pay_link: string
  eq_sn: string
  effect_time: string // 保单生效时间
  created_at: string // 保单创建时间
  from?: string // 使用来源
  id?: number
  is_applets?: JijiaInsranceAppletsValue
}

export function usePinanPay(): {
  payHandle: (data: PayHandleParams) => void
} {
  const vueStore = useStore()
  const $router = useRouter()
  const isMiniProgram = computed(() => {
    // 50455033900248426404
    return vueStore.getters.isMiniProgram
    //return true
  })
  function payHandle(data: PayHandleParams) {
    const action = data.from === 'deviceList' ? 'push' : 'replace' // 从列表跳转过来时需要不适用replace
    if (isMiniProgram.value) {
      // 小程序跳转到中转页
      // Apphost.postMessage(data)
      // console.log('data', data)
      //location.href = data.pay_link

      if (data.id || data.eq_sn) {
        localStorage.setItem('pinanpayCurrentSn', data.eq_sn)
        // 投保后的操作会有保单id，区别设备列表进的会没有保单id
        wx.miniProgram.navigateTo({
          url: `/pages/pingan/epcis/cpc/redirect?from=pingan&url=${encodeURIComponent(
            data.pay_link
          )}`,
        })
        setTimeout(() => {
          $router[action]({
            name: 'insurance-jijia-insurance-detail',
            query: {
              from: 'payed',
              id: data.id,
              eq_sn: data.eq_sn,
            },
          })
        }, 200)
      } else {
        location.href = data.pay_link
      }
      // wx.miniProgram.navigateTo({
      //   url: `/pages/webView?url=${encodeURIComponent(data.pay_link)}`,
      // })
      // setTimeout(() => {
      //   $router[action]({
      //     name: 'insurance-jijia-insurance-detail',
      //     query: {
      //       from: 'payed',
      //       id: data.id,
      //     },
      //   })
      // }, 1000)
    } else {
      // 直接去往支付
      if (isUseIframePay) {
        $router[action]({
          name: 'iframe-wrap',
          query: {
            title: '平安收银台',
            type: 'pingan',
            url: data.pay_link,
          },
        })
      } else {
        location.href = data.pay_link
      }
    }
  }
  return {
    payHandle,
  }
}

export function useMultiplatformOrderAdaptation(): {
  payLinkAdaptationJudge: (data: PayHandleParams) => boolean
} {
  // 多平台订单适
  const vueStore = useStore()
  const $router = useRouter()
  const isMiniProgram = computed(() => vueStore.getters.isMiniProgram)

  function payLinkAdaptationJudge(data: PayHandleParams): boolean {
    const is_applets = data.is_applets
    if (is_applets === 1 && !isMiniProgram.value) {
      // 小程序投保未支付的订单在app出现的情况
      //
      showConfirmModal({
        title: '支付失败',
        message: '当前暂不支持该订单支付，请前往小程序进行支付',
        confirmButtonText: '知道了',
        className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-error-class',
        showCancelButton: false,
      })
      return false
    } else if (is_applets === 2) {
      // 小程序支付上线前投保或者app投保
      if (isMiniProgram.value) {
        // 小程序环境下直接按旧方式支付
        const action = data.from === 'deviceList' ? 'push' : 'replace'
        $router[action]({
          name: 'insurance-jijia-after-submit',
          query: {
            paylink: encodeURIComponent(data.pay_link),
            eq_sn: data.eq_sn,
            effect_time: encodeURIComponent(data.effect_time),
            created_at: encodeURIComponent(data.created_at),
          },
        })
        return false
      }
    }
    return true
  }
  return {
    payLinkAdaptationJudge,
  }
}
